import { DrawerState } from './stateI'

const initialDrawerState: DrawerState = {
  open: false,
}

export default initialDrawerState
